import { call, put, select, take, takeLatest } from 'redux-saga/effects';

import { invalidateAllAssemblyTreeQueries } from 'modules/quotes/quoteItemComponents/assemblyTree/data/utils';
import { collapseComponent } from 'modules/quotes/quoteItemComponents/data/actions';

import quoteService from 'services/quoteService';

import { refreshQuote } from 'store/quotes/actions';
import { getQuoteId } from 'store/quotes/selectors';
import { QUOTE_REFRESH_ERROR, QUOTE_REFRESH_SUCCESS } from 'store/quotes/types';

import {
  deepCopyInPlaceModal,
  deepCopyInPlaceQuoteItem,
  types,
} from './actions';
import { getQuoteItemId } from './reducer';

export default function* root() {
  yield takeLatest(
    types.DEEP_COPY_QUOTE_ITEM_IN_PLACE_REQUEST,
    watchDeepCopyQuoteItemInPlace,
  );
}

function* watchDeepCopyQuoteItemInPlace() {
  try {
    const quoteId = yield select(getQuoteId);
    const quoteItemId = yield select(getQuoteItemId);
    const quoteItemIds = [quoteItemId];

    // deep copy in place
    yield call(quoteService.quoteItems.deepCopyInPlace, quoteId, {
      quoteItemIds,
    });

    // Collapse expanded components
    yield put(collapseComponent());

    // Refresh the quote
    yield put(refreshQuote.request());
    yield take([QUOTE_REFRESH_SUCCESS, QUOTE_REFRESH_ERROR]);

    invalidateAllAssemblyTreeQueries();

    yield put(deepCopyInPlaceModal.close());
    yield put(deepCopyInPlaceQuoteItem.success());
  } catch (error) {
    yield put(deepCopyInPlaceQuoteItem.error(error));
  }
}
